export const getSettingsHomeRedirect = (getters, to) => {
  if (getters.getCurrentRole === 'administrator') {
    return { name: 'general_settings_index', params: to.params };
  }

  return { name: 'canned_list', params: to.params };
};
